import { ApolloClient } from 'apollo-client'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'

import localStore from 'localforage'

import { PATH_GRAPHQL_HTTP, PATH_SHOPIFY_GRAPHQL, SHOPIFY_TOKEN } from '../config'
import { TOKEN_KEY } from '../sagas/auth'

const httpLink = createHttpLink({
  uri: PATH_GRAPHQL_HTTP
})

const authLink = setContext(async (request, { headers }) => {
  const token = await localStore.getItem(TOKEN_KEY)
  return {
    headers: {
      ...headers,
      'X-Auth-Token': token && token.token
    }
  }
})

const cache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Game': return object.gameId
      case 'GameDetails': return object.gameId
      case 'Shot': return object.shotId
      case 'Hole': return object.holeId
      default: return defaultDataIdFromObject(object)
    }
  }
})

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache
})

export default apolloClient

const shopifyHttpLink = createHttpLink({
  uri: PATH_SHOPIFY_GRAPHQL
})

const shopifyAuthLink = setContext(async (request, { headers }) => {
  const token = SHOPIFY_TOKEN
  return {
    headers: {
      ...headers,
      'X-Shopify-Storefront-Access-Token': token
    }
  }
})

const shopifyCache = new InMemoryCache({
  dataIdFromObject: object => {
    switch (object.__typename) {
      default: return defaultDataIdFromObject(object)
    }
  }
})

export const shopifyClient = new ApolloClient({
  link: shopifyAuthLink.concat(shopifyHttpLink),
  cache: shopifyCache
})
